import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import {
  getActiveWhatsAppBranches,
  getBranchMessage,
  openWhatsAppChat,
} from "../../utils/whatsappUtils";
import "./whatsappBranchModal.css";

const formatPhone = (phone) => `+${phone}`;

const BranchCard = ({ country, branchLine, phone, onSelect }) => (
  <button type="button" className="wa-branch-card" onClick={onSelect}>
    <div className="wa-branch-card-info">
      <span className="wa-branch-card-country">{country}</span>
      {branchLine ? (
        <span className="wa-branch-card-meta">{branchLine}</span>
      ) : null}
      <span className="wa-branch-card-phone">{formatPhone(phone)}</span>
    </div>
    <span className="wa-branch-card-icon" aria-hidden="true">
      <FaWhatsapp size={24} />
    </span>
  </button>
);

const WhatsAppBranchModal = ({
  show,
  onHide,
  message = "",
  fallbackPhone = "",
}) => {
  const { t } = useTranslation();
  const branches = getActiveWhatsAppBranches();

  const handleBranchClick = (branch) => {
    openWhatsAppChat(branch.phone, getBranchMessage(branch, message));
    onHide();
  };

  const handleFallbackClick = () => {
    if (fallbackPhone) {
      openWhatsAppChat(fallbackPhone, message);
      onHide();
    }
  };

  const getBranchLine = (branch) => {
    const parts = [branch.branch, branch.department].filter(Boolean);
    return parts.join(" · ");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="wa-branch-modal"
      dialogClassName="wa-branch-dialog"
    >
      <div className="wa-branch-header">
        <div className="wa-branch-title-wrap">
          <span className="wa-branch-title-icon">
            <FaWhatsapp size={18} />
          </span>
          <h2 className="wa-branch-title">{t("whatsapp_select_branch")}</h2>
        </div>
        <button
          type="button"
          className="wa-branch-close"
          onClick={onHide}
          aria-label="close"
        >
          <IoClose size={22} />
        </button>
      </div>

      <Modal.Body className="wa-branch-body">
        {branches.length > 0 ? (
          <ul className="wa-branch-list">
            {branches.map((branch) => (
              <li key={`${branch.country}-${branch.branch}-${branch.phone}`}>
                <BranchCard
                  country={branch.country}
                  branchLine={getBranchLine(branch)}
                  phone={branch.phone}
                  onSelect={() => handleBranchClick(branch)}
                />
              </li>
            ))}
          </ul>
        ) : fallbackPhone ? (
          <ul className="wa-branch-list">
            <li>
              <BranchCard
                country={t("whatsapp_default_sales")}
                phone={fallbackPhone}
                onSelect={handleFallbackClick}
              />
            </li>
          </ul>
        ) : (
          <p className="wa-branch-empty">{t("whatsapp_no_branches")}</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WhatsAppBranchModal;
